export default __webpack_public_path__ + "static/media/636.e1280408.gif";